import { useTranslation } from 'react-i18next';

interface ClearAllFiltersButtonProps {
  onClear: () => void;
}

export const ClearAllFiltersButton = ({ onClear }: ClearAllFiltersButtonProps) => {
  const { t } = useTranslation();

  return (
    <span
      data-testid="clearAllFiltersButton"
      className="sq-text-primary cursorPointer text-interactive text-underline-onhover tw:ml-sq-10 tw:italic"
      onClick={onClear}>
      <span>{t('HOME_SCREEN.CLEAR_ALL')} &times;</span>
    </span>
  );
};
